// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import styled from 'styled-components';
import { categorySort, duplicateSort, EU, generateId, htmlDecode, plural } from '../../_common/api/utility';
import Cart, { itemTypes } from '../../_common/Cart';
import Button from '../../_common/form/Button';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Card from '../Card';
import CheckoutCard from '../../_common/CheckoutCard';
import MenuRoutes from '../MenuRoutes';
import Col from '../../_common/form/Col';
import CheckBox from '../../_common/form/CheckBox';
import HamLink from '../../_common/form/HamLink';
import { HamQuest } from '../../../App';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Modal from '../../_common/Modal';
import { HasFeature, Features } from '../../_common/RequireFeature';


const Item = styled.div`
    padding: 0.3em;
    overflow: hidden;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between
`
const Empty = styled.div`
    text-decoration: underline;
    font-size: 0.8em;
`
const Link = styled.span`
    color: ${({ theme }) => theme.link};
`


const Checkout = ({ ...props }) => {
    const { state: {
        cart
    } } = useGlobalState();
    const awardEnhancementEnabled = HasFeature(Features.AwardEnhancement);

    const [agreed, setAgreed] = useState(cart.find(e => e.productType === itemTypes.washClub) ? true : false);

    const categories = [...new Set(cart.filter(e => !e.isGift).map(e => e.productType))].sort(categorySort);

    const [items] = useState([...new Set(duplicateSort(cart, 'productId').map(e => e.productId))]);

    const routes = MenuRoutes();

    const showTerms = () => {
        HamQuest.get(QuestRoute.merchant.WCTerms)
            .then(res => {
                Modal.Show({
                    title: 'Terms and Conditions',
                    body: <div dangerouslySetInnerHTML={{ __html: htmlDecode(res[0].value) }} />
                })
            })
    }

    return (
        <Card smooth={cart}>
            <Title icon='cart'>Cart</Title>
            {
                cart.length ?
                    <>
                        <Row>
                            <Col>
                                <div><b>Subtotal:</b> {Cart.GetSubTotalPrice()}</div>
                                {
                                    awardEnhancementEnabled
                                        ? <div><b>Discounts:</b> {Cart.GetDiscounts()}</div>
                                        : null
                                }
                                <div><b>Total:</b> {Cart.GetTotalPrice()}</div>
                            </Col>
                            <Empty onClick={() => Cart.Empty()}>Empty Cart</Empty>
                        </Row>
                        <Button onClick={() => Cart.CompletePurchase()} disabled={agreed}>Proceed to checkout ({cart.length} {plural(cart.length, 'item')})</Button>

                        {cart.find(e => e.productType === itemTypes.washClub) && (
                            <Row>
                                <span>I agree to the <Link onClick={showTerms}>Terms and Conditions</Link></span>
                                <CheckBox
                                    standalone
                                    checked={!agreed}
                                    onChange={e => setAgreed(!e.target.checked)}
                                />
                            </Row>
                        )}

                        {
                            cart.find(e => e.isGift) ?
                                <Item key={generateId()}>
                                    <Title>· Gifts</Title>
                                    {
                                        cart
                                            .filter(e => e.isGift)
                                            .map(e => <CheckoutCard item={e} key={generateId()} />)
                                    }
                                </Item> : null
                        }
                        {
                            categories.map(e => {
                                return (
                                    <Item key={generateId()}>
                                        <Title>· {EU(e)}</Title>
                                        {
                                            items.map(id => {
                                                const item = cart.filter(e => !e.isGift).find(f => f.productId === id && f.productType === e);
                                                if (!item) return null;
                                                return <CheckoutCard item={item} key={generateId()} />
                                            })
                                        }
                                    </Item>
                                )
                            })
                        }
                    </> :
                    <>
                        <div>Subtotal {Cart.GetTotalPrice()}</div>
                        <Button to={routes.washes.route}>Buy a Wash</Button>
                        Nothing in your Cart
                    </>
            }
        </Card>
    );
}

export default Checkout;